import { render, staticRenderFns } from "./UndoFinishedTickets.vue?vue&type=template&id=2147f7ac&scoped=true&"
import script from "./UndoFinishedTickets.vue?vue&type=script&lang=js&"
export * from "./UndoFinishedTickets.vue?vue&type=script&lang=js&"
import style0 from "./UndoFinishedTickets.vue?vue&type=style&index=0&id=2147f7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147f7ac",
  null
  
)

export default component.exports